var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-row',[_c('b-col',{attrs:{"sm":"6"}},[_c('RecentUpdatedMeters')],1),_c('b-col',{attrs:{"sm":"6"}},[_c('RecentUpdatedInvoices')],1),_c('b-col',{attrs:{"sm":"6"}},[_c('RecentUpdatedAccounts')],1),_c('b-col',{attrs:{"sm":"6"}},[_c('RecentUpdatedPayments')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }